import { FC } from 'react';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from 'components/Checkbox';

import { CleanupTool } from 'components/DiskCleanupContext';

type Props = {
  name: CleanupTool;
  title: string;
};

const DiskCleanupTool: FC<Props> = ({ name, title, children }) => (
  <TableRow>
    <TableCell>
      <Checkbox name={`${name}.selected`} />
    </TableCell>

    <TableCell>{title}</TableCell>

    {children}
  </TableRow>
);

export default DiskCleanupTool;
